/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : Jul 27, 2025
Folder          : src/components/button
File            : ButtonCompDark.tsx
Description     : 
    This reusable component is a dark button.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/


// Import React Systems
import { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

// Imports MUI Components
import { Button, Tooltip, Link } from "@mui/material"

// Import Functions
import { logoutUser } from "../../../functions/logoutUser"
import { resetInventoryForm } from "../../../functions/resetInventoryForm"

// Import Icon Atom
import Icon from "../../../../components/UI/atoms/icon/Icon"
import Text from "../../../../components/UI/atoms/text/Text"

// Import CSS
import "./styles.css"

const ButtonComp = ({
  buttonId,
  buttonType,
  variant,
  noElevate,
  label,
  noRipple,
  destination,
  background,
  noRead,
  paddings,
  color,
  justify,
  border,
  source,
  hoverTextColor,
  hoverBackground,
  hoverBorder,
  radius,
  selected,
  keys,
  iconned,
  notif,
  type,
  size,
  clickPass,
  isActive,
  setIsModalOpen,
  open,
}) => {

  const navigate = useNavigate();

  // Logout function
  const logoutAccount = () => logoutUser(navigate);
  const [showNotifications, setShowNotifications] = useState(false);

  const [, setEditingKey] = useState(null);
  const [, setItemName] = useState("");
  const [, setPricePerUnit] = useState("");
  const [, setQuantity] = useState("");
  const [, setErrorMessage] = useState("");
  
  const [dropdownOpen, setDropdownOpen] = useState(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownOpen && !event.target.closest('.dropdown-container')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

// Paddings
// notif = 5
// small = 5 10
// regular = 10 15
// medium = 10 20
// large = 15 30
  // Styling
  const style = {
    color: 
      color === "light" ? "#FDF9F3" :
      color === "dark" ? "#59544A" :
      color === "gold" ? "#C5A572":
      selected === keys ? "#FDF9F3" :
      "#2C251E",
    backgroundColor: 
      selected === keys ? "#C5A572" :
      background === "dark" ? "#2E2D2D" :
      background === "none" ? "transparent" :
      isActive ? "rgba(89, 84, 74, .20)" :
      buttonId === "analytics" ? "#FEFEFE" :
      "#C5A572",
    border:
      border === "light" ? "1px solid #C5A572" :
      border === "special" ? "1px solid rgba(89, 84, 74, 0.15)" :
      "none",
    fontSize: "14px",
    top: 
      notif === true ? "8px" :
      "none",
    borderRadius: 
      radius === "special" ? "10px" :
      "50px",
    padding: 
      paddings === "notif" ? "5px" : 
      paddings === "small" ? "5px 10px" :
      paddings === "medium" ? "10px 15px" :
      paddings === "large" ? "10px 20px" :
      "15px 30px",
    width: "100%",
    justifyContent:
      justify === "special" ? "start" :
      "center",
    textTransform: "none",
    fontWeight: 
      isActive ? "bold" : "normal",
    "&:hover": {
      color: 
        selected === keys ? "#FDF9F3" :
        hoverTextColor === "light" ? "#FEFEFE" :
        hoverTextColor === "none" ? "none" :
        hoverTextColor === "special" ? "#A68B6E" :
        isActive ? "none" :
        "#FDF9F3",
      border: 
        hoverBorder === "dark" ? "1px solid #AD8C60" :
        "none",
      backgroundColor: 
        selected === keys ? "#C5A572" :
        hoverBackground === "dark" ? "#70522eff" :
        hoverBackground === "special" ? "rgba(253, 249, 243, .1)" :
        hoverBackground === "none" ? "none" :
        isActive ? "none" :
        "#8F7049",
    },
  }

  return (
    <div>
      <Tooltip
        title={
          !open ? label : 
          null
        }
        placement="right"
        arrow
      >
        <Link href={destination !== "none" ? destination : null} underline="hover">
          <Button
            type={buttonType}
            tabIndex={0}
            disabled={noRead}
            variant={variant}
            disableElevation={noElevate}
            disableRipple={noRipple}
            className={
              type === "default" ? null : 
              !isActive ? "button" : 
              buttonId === "notification" ? "dropdown-container" : 
              null
            }
            onClick={
              buttonId === "inventory" ? 
                () => {
                  resetInventoryForm(
                    setItemName,
                    setPricePerUnit,
                    setQuantity,
                    setEditingKey,
                    setErrorMessage
                  );
                  setIsModalOpen(true);
                } : 
              buttonId === "signIn" ?
                clickPass :
              buttonId === "scheduleAppointment" ?
                clickPass :
              buttonId === "viewPortfolio" ?
                clickPass :
              buttonId === "headerSignIn" ?
                clickPass :
              buttonId === "notification" ? (() => {
                const result = setShowNotifications(!showNotifications);
                if (clickPass) clickPass(result);
                return result;
              }) :
              buttonId === "signOut" ?
                logoutAccount :
              label === "Add Personnel" ?
                setIsModalOpen :
              buttonId === "service" ?
                clickPass :
              buttonId === "analytics" ?
                clickPass :
              null
            }
            sx={style}
          >
            {iconned === true ? (
              <Icon
                src={source}
                size={size}/>
            ) : (
                null
            )}

            {buttonId === "signOut" ? (
              <>
              {open &&
                <Text
                  variant="signoutButton"
                  text={label}/>
              }
              </>
            ) : (
              <>
                {label}
              </>
            )}
            

          </Button>
        </Link>
      </Tooltip>
    </div>
  )
}

export default ButtonComp
